import { useEffect } from 'react';
import { resumeAudioContext } from '../Utils/soundUtil';

export const useAudioContext = () => {
  useEffect(() => {
    // Define a function to resume the audio context on interaction
    const handleUserInteraction = () => {
      resumeAudioContext();
    };

    // Attach event listeners for user interactions
    document.addEventListener("click", handleUserInteraction);
    document.addEventListener("keydown", handleUserInteraction);
    document.addEventListener("touchstart", handleUserInteraction);

    // Clean up the event listeners when the component unmounts
    return () => {
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("keydown", handleUserInteraction);
      document.removeEventListener("touchstart", handleUserInteraction);
    };
  }, []); // Empty dependency array ensures this effect runs only once when the component mounts
};